import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave-2.svg";
import Sitemap from "@/components/Sitemap";

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function SitemapPage({
    global,
    meta,
    jobs_by_location
}) {
    const locale = useLocale();

    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <div className="bg-light-white">
                <SubBanner
                    global={global}
                    pathPrefix={`sitemap.page.sub_banner`}
                    heading={`Sitemap`}
                    content={``}
                    breadcrumb_title={<><span className="active">Sitemap</span></>}
                    wave_color={`light-grey`}
                />
                <Sitemap
                    global={global}
                    pathPrefix={`sitemap.page.jobs_location_landing_page`}
                    post={jobs_by_location}
                />
                <div className="footer bg-light-grey" style={{ marginBottom: '-1px' }}>
                    <FooterWave />
                </div>
            </div>
        </>
    );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
    const global = (await Global()).toJson();
    const jobs_by_location = (await Collection(`jobs_by_location`)).getItems();


    const routerKey = "sitemap";

    return {
        props: {
            global,
            jobs_by_location,
            meta: {
                title: "Sitemap | Tradewind Subs",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search